import { render } from "./Tab.vue?vue&type=template&id=24b5a6d6&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=24b5a6d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24b5a6d6"

export default script